import React, { useState } from 'react';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import UsersTab from '../components/System/UsersTab';
import RolesTab from '../components/System/RolesTab';
import PermissionsTab from '../components/System/PermissionsTab';
import RolePermissionsTab from '../components/System/RolePermissionsTab';

const Users = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('users');

  const items = [
    {
      key: 'users',
      label: t('system.tabs.users'),
      children: <UsersTab isActive={activeTab === 'users'} />
    },
    {
      key: 'roles',
      label: t('system.tabs.roles'),
      children: <RolesTab isActive={activeTab === 'roles'} />
    },
    {
      key: 'permissions',
      label: t('system.tabs.permissions'),
      children: <PermissionsTab isActive={activeTab === 'permissions'} />
    },
    {
      key: 'rolePermissions',
      label: t('system.tabs.rolePermissions'),
      children: <RolePermissionsTab isActive={activeTab === 'rolePermissions'} />
    }
  ];

  return (
    <div className="system-page max-w-6xl mx-auto px-3 sm:px-4 py-4 sm:py-8">
      <h1 className="text-xl sm:text-2xl font-bold text-primary mb-4 sm:mb-6">{t('system.title')}</h1>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        className="system-tabs"
        tabBarGutter={8}
      />
    </div>
  );
};

export default Users;
